<div class='table-responsive'>
    <table class="table table-striped table-sm table-hover">
        <thead 
            class="thead-light"  
            app-datatable-th-lista 
            [id]="id"
            [datatable]="datatable"
            [sorts]="sorts"
            (onSortCambiados)="sortCambiados($event)">
        </thead>
        <tbody *ngIf="loading">
            <tr>
                <td [colSpan]="colspan()" class='text-center'>
                    <div class='big-height'>
                        <ngx-sync-loader></ngx-sync-loader>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="data.length == 0 && !loading">
            <tr>
                <td [colSpan]="colspan()" class='text-center'>No se han encontrado resultados.</td>
            </tr>
        </tbody>
        <tbody *ngIf="data.length > 0 && !loading">
            <ng-container *ngFor="let item of data; let i = index">
                <tr [ngClass]="datatable.rowClass ? datatable.rowClass(item) : ''"
                >
                    <td *ngIf="datatable.collapsing">
                        <app-datatable-cell-collapse [datatable]="datatable" [i]="i" [collapseData]="collapseData"></app-datatable-cell-collapse>
                    </td>
                    <ng-container *ngFor="let col of datatable.columnas">
                        <td *ngIf="col.mostrar !== false">
                            <div [innerHTML]="col.valor(item) | keepHtml"></div>
                        </td>
                    </ng-container>
                </tr>
                <tr [hidden]="!datatable.collapsing || !collapseData || collapseData.length < i || !collapseData[i] || !collapseData[i].open">
                    <td colspan="100vw" *ngIf="datatable.collapsing && datatable.collapsing.collapseFn">
                        <div style="width: 90vw;" [innerHTML]="datatable.collapsing.collapseFn(item) | keepHtml"></div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>